import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class NotificationService {
  constructor(
    private _api: ApiService,
    private toastr: ToastrService,
  ) {}

  getNotifications(query, offset = 0, limit = 10, sort = 'created', ascending = false): Observable<any> {
    const results = this._api
      .get(`/notification?query=${encodeURIComponent(query)}&sort=${sort}&ascending=${ascending}&offset=${offset}&limit=${limit}`)
      .pipe(map((data) => data));
    return results;
  }

  readNotifications(id: any, viewed = true): Observable<any> {
    const results = this._api
      .patch(`/notification/${id}`, {
        id: id,
        viewed: viewed,
      })
      .pipe(map((data) => data));
    return results;
  }

  readAllNotifications(): Observable<any> {
    const results = this._api.post(`/notification/mark`, true).pipe(map((data) => data));
    return results;
  }

  confirmAccountVerifyNotification(id: string): Observable<any> {
    const encodedId = encodeURIComponent(`${id}`);
    const results = this._api.getWithoutAuth(`/notification/${encodedId}/confirm`).pipe(map((data) => data));
    return results;
  }

  sendFeedback(type: string, rating: any, subject: string, followup: any, description: string): Observable<any> {
    const results = this._api
      .post(
        `/notification/feedback?type=${encodeURIComponent(type)}&rating=${rating}&subject=${encodeURIComponent(subject)}&followup=${followup}`,
        description,
      )
      .pipe(map((data) => data));
    return results;
  }

  sendErrorFeedback(description: string): Observable<any> {
    const results = this._api
      .post(
        `/notification/feedback?type=${encodeURIComponent('Bug or Error')}&rating=${0}&subject=${encodeURIComponent(
          'Toastr Error',
        )}&followup=${'false'}`,
        description,
      )
      .pipe(map((data) => data));
    return results;
  }

  showSuccess(msg: string) {
    this.toastr.success(msg);
  }
}
